import { useEffect, useRef, useSyncExternalStore } from 'react'
import {
  abonnerConfirmation,
  type DemandeConfirmation,
  demandesConfirmation,
  repondre,
} from './confirmation'

const AUCUNE: readonly DemandeConfirmation[] = []

/** Rend la première confirmation en attente (`confirmer`), par-dessus la page. */
export function HoteConfirmation() {
  const demandes = useSyncExternalStore(abonnerConfirmation, demandesConfirmation, () => AUCUNE)
  const d = demandes[0]
  return d ? <FenetreConfirmation key={d.id} demande={d} /> : null
}

function FenetreConfirmation({ demande }: { demande: DemandeConfirmation }) {
  const dialogue = useRef<HTMLDialogElement>(null)
  const reponse = useRef(false)
  useEffect(() => {
    dialogue.current?.showModal()
  }, [])
  // Échap, « Annuler », « Confirmer » ou un clic sur le voile ferment la fenêtre : la réponse
  // part à la fermeture, une seule fois.
  const fermer = (oui: boolean) => {
    reponse.current = oui
    dialogue.current?.close()
  }
  return (
    <dialog
      ref={dialogue}
      className="confirmation"
      aria-labelledby={`confirmation-${demande.id}`}
      onClose={() => repondre(demande.id, reponse.current)}
      onClick={(e) => {
        if (e.target === dialogue.current) fermer(false)
      }}
    >
      <p id={`confirmation-${demande.id}`}>{demande.texte}</p>
      {/* « Annuler » d'abord : il prend le curseur à l'ouverture, Entrée n'efface donc rien. */}
      <div className="boutons">
        <button type="button" className="bouton" onClick={() => fermer(false)}>
          Annuler
        </button>
        <button type="button" className="bouton bouton-principal" onClick={() => fermer(true)}>
          Confirmer
        </button>
      </div>
    </dialog>
  )
}
